import { configureBrandFromEnv } from '@parsina/framework/ui/lib/brand';
import { configureClinical } from '@parsina/framework/clinical/src/host.jsx';
import { BFF_URL, BFF_WS_BASE } from './runtimeEnv.js';
import { getToken, getRefresh, getValidToken, refreshAccessToken, logout, parseJwt, isTokenExpired } from './auth.js';
import { activeClinicZone } from './clinicZone.js';

// The brand, before anything else (docs/rebranding/CONTRACT.md): the product's
// name, its credit's name, the languages offered, the calendar and the market.
// The deployment hands it over as env.js's BRAND_B64; without one this is a
// no-op and the panel is Parsina, byte for byte. It is read once, here, because
// App.jsx imports this module first — before the first render and before the
// clinical module, the translator and the date pickers ask for it. The four
// modules imported above read the brand only when called, never while loading.
configureBrandFromEnv();

// The doctor panel as a HOST of the clinical module (docs/CLINICAL_KIT_DESIGN.md).
//
// The visit room and the patient record live in @parsina/framework/clinical so
// the clinic panel can render the same ones. What they need from whichever panel
// renders them is configured here, once, before the first screen mounts — App.jsx
// imports this module first for exactly that reason.
//
// The doctor panel's own BFF, and its own sign-in: nothing about the doctor
// panel's behaviour changes by being a host. The per-render half (navigation,
// the current path) is <ClinicalHostProvider> in App.jsx's AppShell.
configureClinical({
  bffUrl: BFF_URL,
  wsBase: BFF_WS_BASE,
  auth: { getToken, getRefresh, getValidToken, refreshAccessToken, logout, parseJwt, isTokenExpired },
  // «ویزیت همین الان» on the patient's visit history (PM-0535): the walk-in booked and
  // the visit room opened in one press. This panel only — the clinic panel hosts the
  // same tab and already has the walk-in on its پذیرش.
  visitNow: true,
  // The clinic's wall clock (PM-0088), read when the kit asks: the visit room's
  // «امروز» decides whether an order sits in this visit and on its invoice, and
  // the service judges that on the clinic's day (PM-0618 §7.2, PM-0635(2)).
  // null — not known yet, or the doctor's clinics disagree — leaves the kit on
  // the locale's zone, as before. Which clinic, and why: ./clinicZone.js.
  clinicTimeZone: () => activeClinicZone(),
});
